module.exports = __webpack_public_path__ + "static/axis-logo-0fd9ce474c5fb0bf0a2e30abe3a55dce.png";